import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ComponentHelper, WizardPageBaseComponent} from '@utils-lib';
import {AppNameEnum, Bankverbindung, BankverbindungAngabe} from '@nachdigal';

@Component({
    selector: 'common-ui-bankverbindung-angabe',
    templateUrl: './bankverbindung-angabe.component.html'
})
export class BankverbindungAngabeComponent extends WizardPageBaseComponent<BankverbindungAngabe> implements OnInit {

    static nutzdatenPath = 'bankverbindungAngabe';
    static route = 'bankverbindung-angabe';

    public hinweisAnzeigen = false;
    public stammdatenArray: Bankverbindung[];

    constructor(protected readonly activatedRoute: ActivatedRoute) {
        super(activatedRoute);
    }

    public ngOnInit(): void {
        super.ngOnInit();
        const appEnum = ComponentHelper.getAppEnum(this.activatedRoute.snapshot);
        if (appEnum === AppNameEnum.FragebogenKapG) {
            this.hinweisAnzeigen = true;
        }

        this.stammdatenArray = [];
        if (this.stammdaten?.antragsteller?.bankverbindungen) {
            this.stammdatenArray = this.stammdatenArray.concat(this.stammdaten?.antragsteller?.bankverbindungen.array);
        }

        if (this.stammdaten?.unternehmen?.bankverbindungen) {
            this.stammdatenArray = this.stammdatenArray.concat(this.stammdaten?.unternehmen?.bankverbindungen.array);
        }
    }

    protected getStammdatenMappingRules(): Map<string, unknown | Array<unknown>> {
        if (this.stammdaten?.antragsteller?.bankverbindungen != null) {
            return new Map<string, unknown | Array<unknown>>([
                ['bankverbindung', this.stammdaten?.antragsteller?.bankverbindungen]
            ]);
        }
        if (this.stammdaten?.unternehmen?.bankverbindungen != null) {
            return new Map<string, unknown | Array<unknown>>([
                ['bankverbindung', this.stammdaten?.unternehmen?.bankverbindungen]
            ]);
        }
    }
}
